import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import RecoilNexus from "recoil-nexus";
import App from "./App";
import ConfirmRecoilModal from "./components/modal/ConfirmRecoilModal";
import CustomToast from "./components/modal/CustomToast";
import KeyboardController from "./controller/KeyboardController";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import { Toaster } from "react-hot-toast";
import SocketService from "./components/socket/Socket";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ErrorBoundary from "./components/ErrorBoundary";

if (
  process.env.REACT_APP_ENV != undefined &&
  process.env.REACT_APP_ENV === "PRD"
) {
  console.log = () => null;
}

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <>
    <RecoilRoot>
      <RecoilNexus />
      <QueryClientProvider client={queryClient}>
        <SocketService />
        <BrowserRouter
          basename={
            process.env.REACT_APP_BASE_URL ? process.env.REACT_APP_BASE_URL : ""
          }
        >
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
          <KeyboardController />
          <Toaster />
          {/* <ReactQueryDevtools /> */}
        </BrowserRouter>
        <CustomToast message="" type="success" />
        <ConfirmRecoilModal />
      </QueryClientProvider>
    </RecoilRoot>
  </>
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
/*
if (process.env.REACT_APP_ENV != undefined && process.env.REACT_APP_ENV === 'PRD') {
  serviceWorkerRegistration.register();
}
if (process.env.REACT_APP_ENV != undefined && process.env.REACT_APP_ENV === 'DEV') {
  serviceWorkerRegistration.unregister();
}
*/

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
